/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import InfoIcon from '@material-ui/icons/Info';
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify';
import './form.css'
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput"
import ActionAdd from '../../store/action/RegisterTemplate/Add'
import ActionGetCategoryTemplate from '../../store/action/RegisterTemplate/FetchCategory'
import ActionGetLanguageTemplate from '../../store/action/RegisterTemplate/FetchLanguage'
import ActionGetNameSpace from '../../store/action/RegisterTemplate/FetchNamespace'
import { getListPublishedFlow } from '../../store/action/RegisterTemplate/Flow'
import { Modal } from 'react-bootstrap'
import { IsEdit } from '../../store/constants'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import Typography from "@material-ui/core/Typography";
import ActionUploadFileExample from '../../store/action/RegisterTemplate/UploadFileExample'
import { ClientId, DivisionId, SenderId } from "../../helper/HelperAuth";
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import ActionFetchAllDivision from '../../store/action/Division/FetchAll'
import ActionFetchSender from '../../store/action/Sender/FetchAll'
import Tooltip from '@material-ui/core/Tooltip';
import EditorMessage from "../../infra/components/EditorMessage";
import PreviewMessage from "../../infra/components/PreviewMessage";
import ButtonManager from "../RegisterTemplate/ButtonManager";
import { URLFormat, PhoneNoFormat } from "../../infra/constants/regex";
import CheckBoxInputField from "../../infra/components/formInput/CustomCheckBoxInput";
import CardCarousel from "./CardCarousel";
import "./Styles.css";
import CardCarouselPreview from "./CardCarouselPreview";

class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalcharname: 0,
            totalcharfooter: 0,
            totalcharhead: 0,
            totalchar: 0,
            tinyhtml: ' ',
            listLanguage: fromJS({}),
            form: fromJS({
                'template-id': '',
                'template_name': '',
                'category-id': '',
                'language-id': '',
                'header-id': '',
                'message-template': '',
                'client-id': '',
                'division-id': '',
                'sender-id': '',
                'header-template': '',
                'header-example-template': '',
                'header-example-preview': '',
                'header-preview-final': '',
                'header-example-final': '',
                'body-template': '',
                'body-example-template': '',
                'body-example-preview': '',
                'body-preview-final': '',
                'footer-template': '',
                'template-buttons': [],
                'lto-buttons':[],
                'namespace': '',
                'selected-file': null,
                'idSessionTemplate': '',
                'idUploadTemplate': '',
                'file-key': Date.now(),
                'upload-completed': false,
                'add-security-recommendation': null,
                'code-expiration-minutes': 0,
                'template-type': '',
                'limited-offer-text': '',
                'offer-has-expiration': false,
                "template-carousels": [
                    {
                        "raw_message": "",
                        "format": "", // image / video
                        "param_size": 0,
                        "template-buttons": [
                            {
                                'button_type': '',
                                'button_message': '',
                                'button_value': '',
                                'value_type': '',
                            }
                        ],
                    }
                ],
            }),
            hideMediaHeader: 'hide',
            hideTextHeader: 'hide',
            hideExampleHeader: 'hide',
            hideBodyExample: 'hide',
            isAuthentication: false,
            formParamsBody: fromJS({}),
            formParamsBody2: fromJS({}),
            parameterBody: fromJS({}),
            parameterBody2: fromJS({}),
            paramBody: 0,
            paramHeader: 0,
            paramHeaderExample: 0,
            paramCount: 0,
            arrayTemp: [""],
            flagempty: false,
            hideror: 'hide',
            disabledModal: true,
            disabledparam: false,
            tempHeader: '',
            counterParam: 0,
            counterbody: 0,
            counterLang: 1,
            wordingType1: '',
            wordingType2: '',
            wordingMessage1: '',
            wordingMessage2: '',
            flagEnter: 0,
            modal: false,
            templateHeader: fromJS([
                {
                    'header-id': 'hsm',
                    'header-name': 'Text'
                },
                {
                    'header-id': 'template',
                    'header-name': 'Media'
                },
            ]),
            headerMediaType: fromJS([
                {
                    'header-media-id': 'IMAGE'
                },
                {
                    'header-media-id': 'DOCUMENT'
                },
                {
                    'header-media-id': 'VIDEO'
                },
            ]),
            category: fromJS([
                {
                    'id': '1',
                    'name': 'Authentication'
                },
                {
                    'id': '2',
                    'name': 'Marketing'
                },
                {
                    'id': '3',
                    'name': 'Utility'
                },
            ]),
            templateTypeUtility: fromJS([
                {
                    'id': '',
                    'name': 'General'
                },
                {
                    'id': 'carousel',
                    'name': 'Carousel'
                },
            ]),
            templateType: fromJS([
                {
                    'id': '',
                    'name': 'General'
                },
                {
                    'id': 'lto',
                    'name': 'LTO'
                },
                {
                    'id': 'coupon',
                    'name': 'Coupon'
                },
                {
                    'id': 'carousel',
                    'name': 'Carousel'
                },
                {
                    'id': 'catalog',
                    'name': 'Catalog'
                },
                {
                    'id': 'mpm',
                    'name': 'MPM'
                },
                {
                    'id': 'flow',
                    'name': 'Flow'
                },
            ]),
            bodyAuth: {
                id: '*{{1}}* adalah kode verifikasi Anda. Demi keamanan, jangan bagikan kode ini.',
                en: '*{{1}}* is your verification code. For your security, do not share this code.'
            },
            footerAuth: {
                id: 'Kode ini kedaluwarsa dalam',
                en: 'This code expires in'
            },
            loadded: false,
            disabled: false,
            errors: fromJS({}),
            error: '',
            statDisableButton: false, //untuk status button upload dan change
            statGetSessionIdTemp: false, //untuk menyatakan kalau example telah di upload
            fileNameExamp: '', //untuk menampilkan idUpload setelah di upload
            statButtonUpload: '', //button upload none atau tidak.
            actionId: '',
            flagfirst: 0,
            filetype: '',
            disabledHead: false,
            limitedOfferTextLength: 16,
            editorHtml: "",
            editorHtmlCarousels: [""],
            headerTextOnly: false,
            listFlow: fromJS([])
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSavetoDraft = this.handleSavetoDraft.bind(this);
        this.handleParamHeader = this.handleParamHeader.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.renderModal = this.renderModal.bind(this);
        this.handleModal = this.handleModal.bind(this);
        this.handleCancelModal = this.handleCancelModal.bind(this);
        this.handleChangeParam = this.handleChangeParam.bind(this);
        this.renderParamBody = this.renderParamBody.bind(this);
        this.bodyBuild = this.bodyBuild.bind(this);
        this.handlesubmitModal = this.handlesubmitModal.bind(this);
        this.handleOnFileChanged = this.handleOnFileChanged.bind(this);
        this.handleCancelFile = this.handleCancelFile.bind(this);
        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);
        this.setParamSize = this.setParamSize.bind(this);
        this.onEditorCardCarouselChange = this.onEditorCardCarouselChange.bind(this);
        this.setParamSizeCardCarousel = this.setParamSizeCardCarousel.bind(this);
        this.handleChangeInCardCarousel = this.handleChangeInCardCarousel.bind(this);
        this.addMoreCardCarousel = this.addMoreCardCarousel.bind(this);
        this.deleteCardCarousel = this.deleteCardCarousel.bind(this);
        this.setJsonComponentCarousel = this.setJsonComponentCarousel.bind(this);
        this.getFlows = this.getFlows.bind(this);
    }

    async getFlows(clientId) {
        const body = {
            "client_id": clientId
        }
        const response = await getListPublishedFlow(body);
        if(response.ok){
            let data = await response.json();
            this.setState({listFlow: fromJS(data.data)})
        }
    }

    addMoreCardCarousel() {
        const { form, editorHtmlCarousels } = this.state;
        let formVal = form;
        let carousels = form.get("template-carousels");
        let firstCarousel = form.get("template-carousels").get(0);
        let newCarousel = firstCarousel.set("raw-message", "")
        newCarousel = newCarousel.set("raw_message", "")
        newCarousel = newCarousel.set("param_size", 0)
        formVal = formVal.set("template-carousels", fromJS([...carousels, newCarousel]));
        this.setState({ form: formVal, editorHtmlCarousels: [...editorHtmlCarousels, ""] });
    }

    deleteCardCarousel(index) {
        const { form, editorHtmlCarousels } = this.state;
        let valueHtmls = editorHtmlCarousels;
        let formVal = form;
        let carousels = form.get("template-carousels").delete(index);
        formVal = formVal.set("template-carousels", carousels);
        valueHtmls.splice(index, 1);
        this.setState({ form: formVal, editorHtmlCarousels: valueHtmls });
    }
    
    onEditorCardCarouselChange(value, content, index) {
        const { form, editorHtmlCarousels } = this.state;
        let editorHtmlCarouselsUpdate = editorHtmlCarousels;
        let formVal = form;
        let carousels = form.get("template-carousels");
        let carouselsUpdate = carousels.setIn([index, "raw_message"], value)
        formVal = formVal.set("template-carousels", carouselsUpdate);

        if (content) {
            editorHtmlCarouselsUpdate[index] = content;
            this.setState({ form: formVal, editorHtmlCarousels: editorHtmlCarouselsUpdate });
        } else {
            this.setState({ form: formVal });
        }
    }

    setParamSizeCardCarousel(paramSize, value, index) {
        let formVal = this.state.form;
        let carousels = formVal.get("template-carousels");
        let carouselsUpdate;
        if (value) {
            carouselsUpdate = carousels.mergeIn([index], {"param_size": paramSize, "raw_message": value })
        } else {
            carouselsUpdate = carousels.setIn([index, "param_size"], paramSize)
        }
        formVal = formVal.set("template-carousels", carouselsUpdate);
        this.setState({ form: formVal });
    }

    handleChangeInCardCarousel(field, value, index) {
        let formVal = this.state.form;
        let carousels = formVal.get("template-carousels");
        let carouselsUpdate = carousels.setIn([index, field], value)
        formVal = formVal.set("template-carousels", carouselsUpdate);

        this.setState({ form: formVal }); 
    }

    componentDidMount() {
        localStorage.clear();
        this.props.actionGetAllClient();
        this.props.actionGetCategoryTemplate();
        this.props.actionGetLanguageTemplate();
        this.props.actionGetAccessModuleIdAction('Register Template');
        if (this.props.actionType == IsEdit) {
            this.props.actionGetAllDivision(this.props.item.get('client-id'));
            this.props.actionGetAllSender(this.props.item.get('client-id'), this.props.item.get('division-id'));
        }
    }

    componentWillMount() {
        var varActionId = "";
        var dataAkses = null;

        setTimeout(() => {
            dataAkses = this.props.accessmoduleaction;
            if (dataAkses) {
                varActionId = dataAkses.get("action-id");
                this.setState({ actionId: varActionId });
                if(varActionId == 5){
                    this.props.actionFetchSender(ClientId);
                    this.props.actionFetchAllDivision(ClientId);
                    this.props.actionGetNameSpace(ClientId);
                    var formVal = this.state.form;
                    formVal = formVal.set('client-id',ClientId).set('sender-id',SenderId).set('division-id',DivisionId);
                    this.setState({
                      form: formVal,
                      disabledHead: true,
                      actionId :varActionId,
                    })
                }
            }
        }, 3000);
    }

    handleCancel() {
        this.props.handleCancelForm(false);
    }

    onEditorChange(value, content) {
        let formVal = this.state.form;

        formVal = formVal.set('body-template', value);
        formVal = formVal.set('body-preview-final', this.handleParamBodyExample(value));
        
        if (content) {
            this.setState({ form: formVal, tinyhtml: content })
        } else {
            this.setState({ form: formVal })
        }
    }

    setParamSize(paramSize, value) {
        if (paramSize > 0 || this.state.paramHeader > 0) {
            this.setState({ disabledModal: false })
        } else {   
            this.setState({ disabledModal: true })
        }

        let formVal = this.state.form
        if (value) formVal = formVal.set('body-template', value)
        if (value) formVal = formVal.set('body-preview-final', this.handleParamBodyExample(value))
        this.setState({ form: formVal, paramBody: paramSize })
    }

    handleOnFileChanged(event) {
        let newForm = this.state.form;
        let file = event.target.files[0]
        let filet = file.type.split("/")
        filet = filet[0]
        newForm = newForm.set("selected-file", event.target.files[0]);
        this.setState({
            form: newForm,
            filetype: filet
        })
    }

    handleCancelFile() {
        let changeVals = this.state.form;
        changeVals = changeVals.set('idSessionTemplate', '');
        changeVals = changeVals.set('idUploadTemplate', '');
        changeVals = changeVals.set('selected-file', null);
        changeVals = changeVals.set('file-key', Date.now());
        changeVals = changeVals.set('upload-completed', false);
        this.setState({ form: changeVals, statGetSessionIdTemp: false, statDisableButton: false, fileNameExamp: '', statButtonUpload: '' });
    }

    async handleUploadFile() {
        const { form, filetype } = this.state;
        let file = form.get('selected-file');
        let headId = form.get('header-id');
        let headTemp = form.get('header-template');
        if (form.get('template-type') === 'carousel') {
            headTemp = form.get('template-carousels').get(0).get('format').toUpperCase();
        }
        if (headTemp === "IMAGE" && filetype !== "image") {
            toast.error('Error Upload file make sure you uploaded the same format media you choose', toast.POSITION.TOP_RIGHT);
            return false
        }
        else if (headTemp === "VIDEO" && filetype !== "video") {
            toast.error('Error Upload file make sure you uploaded the same format media you choose', toast.POSITION.TOP_RIGHT);
            return false
        } else if (headTemp === "DOCUMENT" && (filetype === "video" || filetype === "image")) {
            toast.error('Error Upload file make sure you uploaded the same format media you choose', toast.POSITION.TOP_RIGHT);
            return false
        }
        if (file && headId === 'template' && (headTemp === 'IMAGE' || headTemp === 'DOCUMENT' || headTemp === 'VIDEO')) {
            let response = await this.props.actionUploadFileExample(file);
            if (response.get('success')) {
                let newForm = form;

                newForm = newForm.set('idSessionTemplate', response.get('idSession'));
                newForm = newForm.set('idUploadTemplate', response.get('idUpload'));
                newForm = newForm.set('upload-completed', true);
                this.setState({
                    form: newForm,
                    statGetSessionIdTemp: true,
                    statDisableButton: true,
                    fileNameExamp: response.get('idUpload'),
                    statButtonUpload: 'none'
                })
            } else {
                toast.error('Error Upload file', toast.POSITION.TOP_RIGHT);
            }
        } else if (file && form.get('template-type') === 'carousel' && (headTemp === 'IMAGE' || headTemp === 'VIDEO')) {
            let response = await this.props.actionUploadFileExample(file);
            if (response.get('success')) {
                let newForm = form;

                newForm = newForm.set('idSessionTemplate', response.get('idSession'));
                newForm = newForm.set('idUploadTemplate', response.get('idUpload'));
                newForm = newForm.set('upload-completed', true);
                this.setState({
                    form: newForm,
                    statGetSessionIdTemp: true,
                    statDisableButton: true,
                    fileNameExamp: response.get('idUpload'),
                    statButtonUpload: 'none'
                })
            } else {
                toast.error('Error Upload file', toast.POSITION.TOP_RIGHT);
            }
        } else {
            toast.error('Check header option and file upload', toast.POSITION.TOP_RIGHT);
        }
    }

    handleMessageAuthType = (form, categoryId, language, minute) => {
        if (categoryId !== '1') {
            return form;
        }

        let formVal = form;
        let body = this.state.bodyAuth.en;
        let footer = this.state.footerAuth.en + ' ' + minute + ' minute.';

        if (language === 'id') {
            body = this.state.bodyAuth.id
            footer = this.state.footerAuth.id+ ' ' + minute + ' menit.';
        }

        this.setState({ tinyhtml: body})

        formVal = formVal.set('body-template', body)
        formVal = formVal.set('body-preview-final', body.replace('{{1}}', '123456'))
        formVal = formVal.set('footer-template', footer)

        return formVal;
    }

    handleClearMessageAuthType = (form) => {
        this.setState({ tinyhtml: ''})
        let formVal = form;
        formVal = formVal.set('body-template', '')
        formVal = formVal.set('body-preview-final', '')
        formVal = formVal.set('footer-template', '')
        return formVal;
    }

    handleChange(field, value) {
        var formVal = this.state.form;
        var charheader = this.state.totalcharhead
        var charfooter = this.state.totalcharfooter
        var charname = this.state.totalcharname
        if (field === 'header-id') {
            if (value === 'hsm') {
                if (formVal.get('template-type') === 'lto') {
                    this.setState({ hideMediaHeader: 'hide', hideTextHeader: 'hide', paramHeader: 0 })
                } else {
                    this.setState({ hideMediaHeader: 'hide', hideTextHeader: '', paramHeader: 0  })
                }
            } else if (value === 'template') {
                this.setState({ hideMediaHeader: '' })
                this.setState({ hideTextHeader: 'hide' })
                this.setState({ paramHeader: 0 })
            } else {
                charheader=0
                this.setState({ hideMediaHeader: 'hide' })
                this.setState({ hideTextHeader: 'hide' })
                this.setState({ hideExampleHeader: 'hide' })
                this.setState({ paramHeader: 0, disabledparam:false })
            }
            if (this.state.paramBody === 0) {
                this.setState({disabledModal:true})
            }
            formVal = formVal.set(field, value).set('header-template', '')
            formVal = formVal.set(field, value).set('header-preview-final', '')
            this.setState({ form: formVal })
        }

        if (field === 'header-template') {
            if (formVal.get('header-id') === 'hsm') {
                formVal = formVal.set('header-preview-final', value);
                this.setState({ form: formVal })
                let cekparamheader = ''
                let ind = 0;
                let tempstr = ''
                let flag = 0
                let paramarr = []
                if (value.length > 60) {
                    value = value.substr(0, 60)
                    charheader = value.length
                } else {
                    charheader = value.length
                }
                for (let i = 0; i < value.length; i++) {
                    var regex = /[^0-9]/g;
                    if (value[i] === "{" && value[i + 1] == "{") {
                        ind = value.indexOf("}", i)
                        if (ind < 0) {
                            continue
                        } else if (value[ind + 1] === "}") {
                            tempstr = value.substring(i + 2, ind)
                            if (tempstr.match(regex) == null) {
                                cekparamheader = value.substring(i, ind + 2);
                                if(formVal.get('header-example-template')) {
                                    formVal = formVal.set('header-preview-final', value.replace(cekparamheader, formVal.get('header-example-template')));
                                }
                                if (parseInt(tempstr) > 1 || parseInt(tempstr) < 1) {
                                    value = value.replace(cekparamheader, "")
                                    break
                                }
                                if (tempstr == paramarr[0]) {
                                    value = value.replace(cekparamheader, "")
                                    break
                                }
                                if (flag == 0) {
                                    paramarr.push(tempstr)
                                    flag += 1
                                    this.setState({ disabledModal: false, disabledparam: true, paramHeader: 1 })
                                } else {
                                    this.setState({ hideror: 'hide' })
                                    continue
                                }

                            }
                        }
                    } else {
                        if (flag == 1) {
                            continue
                        } else {
                            if (this.state.paramBody > 0) {
                                this.setState({ disabledModal: false, disabledparam: false, paramHeader: 0 })
                            } else {
                                this.setState({ disabledModal: true, disabledparam: false, paramHeader: 0 })
                            }
                        }
                    }
                }
            }
            formVal = formVal.set(field, value);
            this.setState({ form: formVal })
        }

        if (field === 'client-id') {
            this.setState({ client_id: value })
            if (value == null) value = -1;
            this.props.actionFetchAllDivision(value);
            this.props.actionFetchSender(value);
            this.props.actionGetNameSpace(value);
            
            formVal = formVal.set(field, value);
            this.setState({ form: formVal })

            if (formVal.get('template-type') === 'flow') {
                this.getFlows(value);
            }
        }

        if (field === 'template_name') {
            value = value.replace(/[^\w\s]/gi, '')
            value = value.replace(/ /g, "_");
            value = value.toLowerCase()
            if (value.length > 512) {
                value = value.substr(0, 512)
                charname = value.length
            } else {
                charname = value.length
            }
            formVal = formVal.set(field, value);
            this.setState({ form: formVal })
        }

        if (field === 'header-example-template') {
            let textHeader = this.state.form.get('header-template')
            let textHeaderReplace = ''
            let stringParam = ''
            for (let i = 0; i < textHeader.length; i++) {

                if (textHeader[i] == "{" && textHeader[i + 1] == "{") {
                    stringParam = (textHeader.substring(i, i + 5))
                    textHeaderReplace = textHeader.replace(stringParam, " " + value + " ")
                }
            }
            formVal = formVal.set('header-example-template', value);
            formVal = formVal.set('header-example-preview', textHeaderReplace);
            this.setState({ form: formVal })
        }
        if (field === 'footer-template') {
            if (value.length > 60) {
                value = value.substr(0, 60)
                charfooter = value.length
            } else {
                charfooter = value.length
            }
        }
        if (field === 'category-id') {
            formVal = formVal.set('template-type', '').set('template-buttons', fromJS([]));
            if (value === '1') {
                this.setState({ isAuthentication: true });
                formVal = this.handleMessageAuthType(formVal, value, formVal.get('language-id'), formVal.get('code-expiration-minutes'));
            } else {
                this.setState({ isAuthentication: false });
                if (formVal.get('category-id') === '1') {
                    formVal = this.handleClearMessageAuthType(formVal);
                }
            }
        }
        if (field === 'language-id') {
            formVal = this.handleMessageAuthType(formVal, formVal.get('category-id'), value, formVal.get('code-expiration-minutes'));
        }
        if (field === 'code-expiration-minutes') {
            formVal = this.handleMessageAuthType(formVal, formVal.get('category-id'), formVal.get('language-id'), value);
        }

        if (field === 'template-type') {
            this.setState({ hideMediaHeader: 'hide', hideExampleHeader: 'hide', hideTextHeader: 'hide', paramHeader: 0  })
                if (this.state.paramBody === 0) {
                    this.setState({disabledModal:true})
                }
            formVal = formVal.set('header-id', '').set('header-template', '').set('header-preview-final', '')
            formVal = formVal.set('template-buttons', fromJS([]));
            if (value === 'flow' && formVal.get('client-id')) {
                this.getFlows(formVal.get('client-id'));
            }
            if (value === 'lto') {
                formVal = formVal.set('footer-template', '');
                this.setState({ hideMediaHeader: 'hide', hideTextHeader: 'hide', hideExampleHeader: 'hide', paramHeader: 0 })
                if (this.state.paramBody === 0) {
                    this.setState({disabledModal:true})
                }
                formVal = formVal.set(field, value).set('header-template', '')
                formVal = formVal.set(field, value).set('header-preview-final', '')
            }
            if (value === 'carousel') {
                formVal = formVal.set('footer-template', '');
                if (formVal.get('template-carousels') === undefined || formVal.get('template-carousels').size === 0) {
                    const cardCarousel = [
                        {
                            'raw-message': '',
                            'format': '', // image / video
                            'param_size': 0,
                            'template-buttons': [
                                {
                                    'button_type': '',
                                    'button_message': '',
                                    'button_value': '',
                                    'value_type': '',
                                }
                            ],
                        }
                    ]
                    formVal = formVal.set("template-carousels", fromJS(cardCarousel));
                }   
            }
            if (value === 'catalog' || value === 'mpm' || value === 'carousel') {
                formVal = formVal.set('header-id', 'hsm')
                this.setState({ hideTextHeader: '' })
                this.setState({headerTextOnly: true})
            } else {
                this.setState({headerTextOnly: false})
            }
        }

        formVal = formVal.set(field, value);
        this.setState({ form: formVal, totalcharhead: charheader, totalcharfooter: charfooter, totalcharname: charname })
    }

    //cek satu
    async handleParamHeader() {
        const { form, paramHeader } = this.state
        this.setState({ hideExampleHeader: '' })
        let formVal = this.state.form
        let textBody = form.get('header-template')
        let counterParam = paramHeader
        if (paramHeader > 0) {
            this.setState({ disabledparam: true, disabledModal: false })
            return false
        } else {
            this.setState({ disabledparam: false, disabledModal: true })
        }

        if (textBody.length > 54) {
            counterParam = 0
        } else {
            counterParam = counterParam + 1
            textBody = `${textBody} {{${counterParam}}}`
        }
        formVal = formVal.set('header-template', textBody);
        formVal = formVal.set('header-preview-final', textBody);
        this.setState({ form: formVal })
        this.setState({ paramHeader: counterParam, totalcharhead: textBody.length })
        if (counterParam > 0) {
            this.setState({ disabledparam: true, disabledModal: false })
        } else {
            this.setState({ disabledparam: false, disabledModal: true })
        }

        if (this.state.paramBody > 0) {
            this.setState({ disabledModal: false })
        }
    }

    handleParamBodyExample(bodyValue) {
        const { formParamsBody, form } = this.state;
        if (form.get('category-id') === '1') {
            return bodyValue.replace('{{1}}', '123456')
        }
        //replace param if exist
        let stringIndex = ''
        let stringcheck = ''
        let index = 0
        let tempstr = ''
        let stringParam2 = ''
        var test_str = ''
        let strtempo = ''
        var regex = /[^0-9]/g;
        if (this.state.counterParam !== 0) {
            for (let i = 0; i < bodyValue.length; i++) {
                if (bodyValue[i] === "{" && bodyValue[i + 1] === "{") {
                    index = bodyValue.indexOf("}", i)
                    if (bodyValue[index + 1] === "}") {
                        strtempo = bodyValue.substring(i, index + 2)
                        if (strtempo.length > 4) {
                            let tempor = strtempo.substring(2, strtempo.length - 2)
                            if (tempor.match(regex) == null) {
                                stringIndex = bodyValue.substring(i, index + 2)
                                stringcheck = stringIndex.substring(2, stringIndex.length - 2)
                                tempstr = bodyValue.substring(i + 2, index)
                                if (parseInt(tempstr) > this.state.counterParam) continue
                                stringParam2 = (bodyValue.substring(i, index + 2))
                                if (formParamsBody.get("param-" + tempstr) === undefined
                                    || formParamsBody.get("param-" + tempstr) === ""
                                    || formParamsBody.get("param-" + tempstr) === ' ') continue
                                bodyValue = bodyValue.replace(stringParam2, formParamsBody.get("param-" + tempstr))
                                test_str = bodyValue
                            } else {
                                continue
                            }
                        } else {
                            continue
                        }
                    } else {
                        continue
                    }
                }
            }
        } else {
            test_str = bodyValue
        }
        
        return test_str;
    }


    handleSelectChange(field) {
        var formVal = this.state.form;
        formVal = formVal.set(field, window.event.target.value);
        this.setState({ form: formVal })
    }

    validateTemplateButtons(templateButtons) {
        const { form } = this.state;
        var isValid = true
        let hasCopyCode = false;
        let copyCodeIndex;
        let hasUrlBtn = false;
        let listError = [];
        for (const [index, button] of templateButtons.entries()) {
            // Button message validation
            const btnMsg = button.get('button_message');
            if (btnMsg.length > 25 || btnMsg.length === 0 || btnMsg.replace(/\s/g, '').length === 0) {
                listError.push(btnMsg.length > 25 ? 'Button Message must be less than 25 characters' : 'Button Message must be filled');
            }

            // Button type validation
            const buttonType = button.get('button_type') == null ? '' : button.get('button_type').toLowerCase();
            if (buttonType === 'url') {
                if (form.get('category-id') !== '1') {
                    hasUrlBtn = true;
                    if (button.get('button_value').length === 0) {
                        listError.push('URL must be filled');
                    } else if (!button.get('button_value').match(URLFormat)) {
                        listError.push("Invalid URL format, use 'protocol://address'");
                    } else if (button.get('value_type') === '') {
                        listError.push('Please select URL Type');
                    } else if (button.get('button_value').includes('{{1}}') && button.get('value_type') !== 'dynamic') {
                        listError.push('Please select URL Type Dynamic if the URL have a param tag');
                    } else if (!button.get('button_value').includes('{{1}}') && button.get('value_type') === 'dynamic') {
                        listError.push('Please add a param tag in URL if the URL Type is Dynamic');
                    }
                } else if (button.get('otp_type') === 'ONE_TAP') {
                    if (!button.get('signature_hash') || !button.get('package_name') || !button.get('autofill_text')) {
                        listError.push("Autofill text, Package Name, and Signature Hash must be filled");
                    }
                }
            } else if (buttonType === 'phone_number') {
                if (button.get('button_value').length === 0) {
                    listError.push('Phone Number must be filled');
                } else if (!button.get('button_value').match(PhoneNoFormat)) {
                    listError.push('Invalid phone number format');
                }
            } else if (buttonType === 'copy_code') {
                hasCopyCode = true;
                copyCodeIndex = index;
            } else if (!['quick_reply', 'catalog', 'mpm', 'flow', ''].includes(buttonType)) {
                listError.push('Invalid Button Type');
            }
        }

        if (form.get("template-type") === "coupon" && !hasCopyCode) {
            listError.push("Coupon template must have a copy code button");
        }
        if (form.get("template-type") === "lto" && hasCopyCode && copyCodeIndex !== 0) {
            listError.push("The copy code button should be first");
        }
        if (form.get("template-type") === "lto" && !hasUrlBtn) {
            listError.push("URL button is required");
        }
        if (listError.length > 0) {
            isValid = false;
            listError.forEach(error => toast.error(error, toast.POSITION.TOP_RIGHT))
        }
        return isValid
    }

    validateForm(mediaType) {
        let {form, formParamsBody, statGetSessionIdTemp} = this.state;

        //validation
        const requiredFields = [
            { key: 'client-id', message: 'Client can not be empty' },
            { key: 'division-id', message: 'Division can not be empty' },
            { key: 'sender-id', message: 'Sender can not be empty' },
            { key: 'category-id', message: 'Category can not be empty' },
            { key: 'template_name', message: 'Template name can not be empty' },
            { key: 'language-id', message: 'Language can not be empty' }
        ];
        for (const field of requiredFields) {
            if (!form.get(field.key)) {
                toast.error(field.message, toast.POSITION.TOP_RIGHT);
                return false;
            }
        }

        if (!this.state.isAuthentication) {
            if (!form.get('body-template')) {
                toast.error('Body can not be empty', toast.POSITION.TOP_RIGHT);
                return false;
            }
            if (form.get('header-id') === 'template' && (mediaType === '' || mediaType == null)) {
                toast.error('Header Template can not be empty', toast.POSITION.TOP_RIGHT);
                return false;
            }
            if (this.state.paramBody > 0 && ((this.state.counterParam != this.state.paramBody) || !this.state.flagempty)) {
                if (this.state.paramBody > formParamsBody.size) {
                    toast.error('Body sample is mandatory please add sample for body parameter before submit', toast.POSITION.TOP_RIGHT);
                    this.setState({ hideror: '' });
                    return false;
                }
            }
            if (form.get('header-example-template') === '' && this.state.paramHeader > 0) {
                toast.error('Header sample is mandatory please add sample for header parameter before submit', toast.POSITION.TOP_RIGHT);
                this.setState({ hideror: '' });
                return false;
            }
            if (form.get('header-id') === 'template' && form.get('upload-completed') !== true) {
                toast.error('Media file must be uploaded', toast.POSITION.TOP_RIGHT);
                return false;
            }
            if (this.state.totalchar > 1024) {
                toast.error('Body message template reach maximum character permitted,check body message template', toast.POSITION.TOP_RIGHT);
                return false;
            }
            if (form.get('body-template').match("\n\n\n")) {
                toast.error('Body message template contains more than 2 concecutive spacing enter check your body message', toast.POSITION.TOP_RIGHT);
                return false;
            }
            if (form.get('template-type') === 'lto' && !form.get('limited-offer-text').length) {
                toast.error('Limitted-offer text must be filled');
                return false;
            }
            if (form.get('template-type') === 'lto' && form.get('header-id') === 'template' && form.get('header-template') !== 'IMAGE' && form.get('header-template') !== 'VIDEO') {
                toast.error('Media Type must be IMAGE or VIDEO', toast.POSITION.TOP_RIGHT);
                return false;
            }
            if (form.get('template-type') === 'mpm' && (form.get('header-template') === '' || form.get('header-template') == null)) {
                toast.error('A header is required for templates MPM', toast.POSITION.TOP_RIGHT);
                return false;
            }
            if (['catalog', 'lto', 'mpm', 'flow'].includes(form.get('template-type')) && form.get('template-buttons').size === 0) {
                toast.error('Button field is mandatory');
                return false;
            }
            if (form.get('template-type') === 'carousel') {
                if (!this.validateCarousel(form.get("template-carousels"))) return false;
                if (!statGetSessionIdTemp) {
                    toast.error('Card header sample is mandatory please add sample for card header parameter before submit', toast.POSITION_TOP_RIGHT);
                    return false;
                }
            }
        } else {
            if (form.get('code-expiration-minutes') > 90) {
                toast.error("Code Expiration can't more than 90", toast.POSITION_TOP_RIGHT);
                return false;
            }
            if (form.get('template-buttons').size < 1) {
                toast.error('Button field is mandatory', toast.POSITION_TOP_RIGHT);
                return false;
            }
        }
        if (this.state.totalcharname > 512) {
            toast.error('Template message name reached maximum permitted,check your template name', toast.POSITION_TOP_RIGHT);
            return false;
        }
        return this.validateTemplateButtons(form.get('template-buttons'));
    }

    validateCarousel(carousel) {
        let isValid = true;
        let listError = []
        let isButtonCardValid = true;
        let isFormatValid = true;
        let isMessageValid = true;
        let isAllCardHaveButton = true;
        let isAllCardHaveSameButton = true;

        const formatFirstCard = carousel.getIn([0, "format"]);
        const firstCardButton = carousel.getIn([0, "template-buttons"]);

        for (const card of carousel) {
            const isButtonValid = this.validateTemplateButtons(card.get("template-buttons"))
            if (!isButtonValid) {
                isButtonCardValid = false;
            }
            if (!card.get("template-buttons").size) {
                isAllCardHaveButton = false;
            }
            if (card.get("template-buttons").size !== firstCardButton.size) {
                isAllCardHaveSameButton = false;
            } else {
                for (let index = 0; index < card.get("template-buttons").size; index++) {
                    if (card.get("template-buttons").getIn([index, "button-type"]) !== firstCardButton.getIn([index, "button-type"])) {
                        isAllCardHaveSameButton = false;
                    }
                }
            }
            if (card.get("format") !== formatFirstCard || !card.get("format") || card.get("format") === "") {
                isFormatValid = false;
            }
            if (!card.get("raw_message").length) {
                isMessageValid = false;
            }
        }

        if (!isFormatValid) {
            listError.push("The card header format must have selected Image or Video and must be the same on all cards")
        }
        if (!isMessageValid) {
            listError.push("The card body message must be filled")
        }
        if (!isAllCardHaveButton) {
            listError.push("At least one button required for a card")
        }
        if (!isAllCardHaveSameButton) {
            listError.push("Each card must have the same number of buttons and the same button type")
        }
        if (!isButtonCardValid) {
            isValid = false;
        }
        if (listError.length > 0) {
            isValid = false;
            listError.forEach(error => toast.error(error, toast.POSITION.TOP_RIGHT))
        }

        return isValid;
    }

    setRequestCarousel(carouselItems){
        const { form } = this.state;
        let carouselRequest = [];
        for (const [index, item] of carouselItems.entries()) {
            let jsonRequest = this.setJsonComponentCarousel(item, form);
            let carouselItem = {
                "jsonRequest": JSON.stringify(jsonRequest),
                "raw_message": item.get('raw_message'),
                "format": item.get('format').toUpperCase(),
                "idUpload": form.get('idUploadTemplate'),
                "total_param_body": item.get('param_size'),
                "button": item.get('template-buttons').toJS()
            };
            carouselRequest.push(carouselItem);
        }
        return carouselRequest;
    }

    async handleSavetoDraft() {
        const { form, paramBody, paramHeader } = this.state;
        let mediaType = "";
        let rawHeader = "";
        let formatJrHeader = form.get('header-id');
        let strHeaderId = '';
        if (form.get('header-id') === 'template') {
            mediaType = form.get('header-template').toLowerCase();
            strHeaderId = 'template';
        } else {
            if (form.get('header-id') === 'hsm') {
                rawHeader = form.get('header-template');
            }
            mediaType = 'text'
            formatJrHeader = 'TEXT';
            strHeaderId = 'hsm';
        }

        if(!this.validateForm(mediaType)) return false;

        let messageDetail = {
            "lang_code": form.get('language-id'),
            "jsonRequest": this.generateJsonRequest(),
            "statusTemplate": "0",
            'button': form.get('template-buttons'),
        }

        if (mediaType !== 'text') {
            messageDetail['idUpload'] = form.get('idUploadTemplate');
            messageDetail['idSession'] = form.get('idSessionTemplate');
        }
        
        if(form.get('category-id') === '1') {
            messageDetail['type'] = 'hsm';
            messageDetail['media_type'] = 'text';
            messageDetail['add_security_recommendation'] = form.get('add-security-recommendation');
            messageDetail['code_expiration_minutes'] = form.get('code-expiration-minutes');
            messageDetail['raw_message'] = form.get('body-template');
            messageDetail['raw_message_footer'] = form.get('footer-template');
            messageDetail['total_param_body'] = 1;
        } else {
            messageDetail['type'] = strHeaderId;
            messageDetail['media_type'] = mediaType;
            messageDetail['raw_message'] = form.get('body-template');
            messageDetail['raw_message_header'] = rawHeader;
            messageDetail['raw_message_footer'] = form.get('footer-template');
            messageDetail['total_param_body'] = `${paramBody}`;
            messageDetail['total_param_header'] = `${paramHeader}`;

            if (form.get('template-type') === "lto") {
                messageDetail['raw_message_footer'] = '';
                messageDetail['limited_offer_text'] = form.get('limited-offer-text');
                messageDetail['offer_has_expiration'] = form.get('offer-has-expiration')===true ? 1 : 0;
            }
            if (form.get('template-type') === 'carousel') {
                messageDetail['raw_message_footer'] = '';
                messageDetail['carousel'] = this.setRequestCarousel(form.get("template-carousels"));
                messageDetail['idUpload'] = form.get('idUploadTemplate');
                messageDetail['idSession'] = form.get('idSessionTemplate');
            }
        }

        let data = {
            "client_id": `${form.get('client-id')}`,
            "division_id": form.get('division-id'),
            "sender_id": form.get('sender-id'),
            "idCategory": form.get('category-id'),
            "templateName": form.get('template_name'),
            "templateType": form.get('template-type'),
            "name_space": form.get('namespace'),
            "messageDetail": messageDetail
        }
        let body = {
            "data": data
        }

        let response = await this.props.actionAdd(body)

        if (response.ok) {
            toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        } else {
            toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
    }

    setJsonComponentCarousel(card, form){
        let jsonRequestCarousel = [];
        let headerRequest = {
            "type": "HEADER",
            "format": card.get('format').toUpperCase(),
            "example": {
                "header_handle": [form.get('idUploadTemplate')]
            }
        };
        
        let bodyRequest = {
            "type": "BODY",
            "text": card.get('raw_message')
        };
        if (card.get('param_size') > 0) {
            let exampleBodyText = [];
            for (let i = 0; i < card.get('param_size'); i++) {
                exampleBodyText.push('example'+(i+1))
            }
            bodyRequest["example"] = {
                "body_text": [exampleBodyText]
            }
        }

        let listRequestButton = [];
        card.get('template-buttons').forEach((btn, idx) => {
            let btnType = btn.get('button_type') ? btn.get('button_type').toLowerCase() : '';
            if(btnType === 'quick_reply') {
                listRequestButton.push({
                    type: 'QUICK_REPLY',
                    text: btn.get('button_message'),
                });
            }
            if(btnType === 'phone_number') {
                listRequestButton.push({
                    type: btn.get('button_type'),
                    text: btn.get('button_message'),
                    phone_number: btn.get('button_value'),
                });
            }
            if(btnType === 'url') {
                listRequestButton.push({
                    type: btn.get('button_type'),
                    text: btn.get('button_message'),
                    url: btn.get('button_value'),
                    example:[
                        btn.get('button_value').replace('{{1}}', 'example')
                    ]
                });
            }
        })
        let buttonRequest = {
            "type": "BUTTONS",
            "buttons": listRequestButton
        }
        jsonRequestCarousel.push(headerRequest);
        jsonRequestCarousel.push(bodyRequest);
        jsonRequestCarousel.push(buttonRequest);
        return jsonRequestCarousel;
    }

    generateJsonRequest() {
        const { form, paramBody, paramHeader, formParamsBody } = this.state;
        let existButton = false
        let footerJson = {}
        let buttonJson = {}
        let headerJson = {}
        let bodyJson = {}
        let jsonRequest = []
        let examplebody = []
        
        for (let i = 0; i < paramBody; i++) {
            examplebody.push(formParamsBody.get("param-" + (i + 1)))
        }
        
        if(this.state.isAuthentication) {
            bodyJson = {"type": "BODY"}
            footerJson = {"type": "FOOTER"}
            if(form.get('add-security-recommendation') != null) bodyJson["add_security_recommendation"] = form.get('add-security-recommendation');
            if(form.get('code-expiration-minutes') > 0) footerJson['code_expiration_minutes'] = parseInt(form.get('code-expiration-minutes'));
            jsonRequest.push(bodyJson);
            jsonRequest.push(footerJson);
        } else {
            if (form.get('body-template') !== '' && paramBody > 0) {
                bodyJson = {
                    "type": "BODY",
                    "text": form.get('body-template'),
                    "example": {
                        "body_text": [examplebody]
                    }
    
                }
                jsonRequest.push(bodyJson)
            } else if (form.get('body-template') !== '') {
                bodyJson = {
                    "type": "BODY",
                    "text": form.get('body-template')
                }
                jsonRequest.push(bodyJson)
            }
    
            if (form.get('header-id') === 'template') {
                if (form.get('idUploadTemplate') !== "") {
                    headerJson = {
                        "type": "HEADER",
                        "format": form.get('header-template'),
                        "example": {
                            "header_handle": form.get('idUploadTemplate')
                        }
                    }
                } else {
                    headerJson = {
                        "type": "HEADER",
                        "format": form.get('header-template')
                    }
                }
                jsonRequest.push(headerJson)
            } else {
                if (form.get('header-template') !== '' && paramHeader > 0) {
                    headerJson = {
                        "type": "HEADER",
                        "format": 'TEXT',
                        "text": form.get('header-template'),
                        "example": {
                            "header_text": [form.get('header-example-final')]
                        }
                    }
                    jsonRequest.push(headerJson)
                } else if (form.get('header-template') !== '') {
                    headerJson = {
                        "type": "HEADER",
                        "format": 'TEXT',
                        "text": form.get('header-template'),
                    }
                    jsonRequest.push(headerJson)
                }
            }

            if (form.get('template-type') === 'lto') {
                jsonRequest.push({
                    "type": "limited_time_offer",
                    "limited_time_offer":{
                        "text": form.get('limited-offer-text'),
                        "has_expiration": form.get('offer-has-expiration')
                    }
                });
            }

            if (form.get('template-type') === 'carousel') {
                let carouselItems = form.get('template-carousels');
                let cardsCarousel = [];
                carouselItems.forEach((item, index) => {
                    let jsonRequestCarousel = this.setJsonComponentCarousel(item, form);
                    cardsCarousel.push({
                        "components": jsonRequestCarousel,
                    });
                });
                jsonRequest.push({
                    "type": "CAROUSEL",
                    "cards": cardsCarousel
                });
            }

            if (form.get('footer-template') !== '') {
                footerJson = {
                    "type": "FOOTER",
                    "text": form.get('footer-template')
                }
    
                jsonRequest.push(footerJson)
            }
        }

        let templateButtons = form.get('template-buttons').toJS();
        if (templateButtons.length > 0) {
            existButton = true
            let jsonRequestButton = [];
            for(let i = 0; i < templateButtons.length; i++) {
                let buttonType = templateButtons[i].button_type ? templateButtons[i].button_type.toLowerCase() : '';
                if(buttonType === 'quick_reply') {
                    jsonRequestButton.push({
                        type: 'QUICK_REPLY',
                        text: templateButtons[i].button_message,
                    });
                } else if (buttonType === 'copy_code'){
                    jsonRequestButton.push({
                        type: 'copy_code',
                        example: 'example123',
                    });
                } else if (buttonType === 'url') {
                    if(templateButtons[i].otp_type) {
                        if(templateButtons[i].otp_type === 'COPY_CODE') {
                            jsonRequestButton.push({
                                type: 'OTP',
                                otp_type: templateButtons[i].otp_type,
                                text: templateButtons[i].button_message,
                            });
                        } else if (templateButtons[i].otp_type === 'ONE_TAP') {
                            jsonRequestButton.push({
                                type: 'OTP',
                                otp_type: templateButtons[i].otp_type,
                                text: templateButtons[i].button_message,
                                autofill_text: templateButtons[i].autofill_text,
                                package_name: templateButtons[i].package_name,
                                signature_hash: templateButtons[i].signature_hash,
                            });
                        }
                    } else {
                        jsonRequestButton.push({
                            type: templateButtons[i].button_type,
                            text: templateButtons[i].button_message,
                            url: templateButtons[i].button_value,
                            example:[
                                templateButtons[i].button_value.replace('{{1}}', 'example' + (i+1))
                            ]
                        });
                        
                    }
                } else if (buttonType === 'phone_number') {
                    jsonRequestButton.push({
                        type: templateButtons[i].button_type,
                        text: templateButtons[i].button_message,
                        phone_number: templateButtons[i].button_value,
                    });
                } else if (buttonType === 'catalog' || buttonType === 'mpm') {
                    jsonRequestButton.push({
                        type: templateButtons[i].button_type,
                        text: templateButtons[i].button_message,
                    });
                } else if (buttonType === 'flow') {
                    jsonRequestButton.push({
                        type: templateButtons[i].button_type,
                        text: templateButtons[i].button_message,
                        flow_id: templateButtons[i].flow_id,
                        navigate_screen: templateButtons[i].navigate_screen,
                        flow_action: templateButtons[i].flow_action,
                    });
                }
            }

            buttonJson = {
                "type": "BUTTONS",
                "buttons": jsonRequestButton
            }
        }

        if (existButton === true) jsonRequest.push(buttonJson)
        console.log("payload json")
        console.log(jsonRequest)
        return JSON.stringify(jsonRequest);
    }

    async handleSubmit(dispatch) {
        const { form, paramBody, paramHeader } = this.state;
        let mediaType = "";
        let rawHeader = "";
        let strHeaderId = '';
        let formatJrHeader = form.get('header-id');
        if (form.get('header-id') === 'template') {
            mediaType = form.get('header-template').toLowerCase();
            strHeaderId = 'template';
        } else {
            if (form.get('header-id') === 'hsm') {
                rawHeader = form.get('header-template');
            }
            mediaType = 'text'
            formatJrHeader = 'TEXT';
            strHeaderId = 'hsm';
        }

        if(!this.validateForm(mediaType)) return false;

        let messageDetail = {
            "lang_code": form.get('language-id'),
            "jsonRequest": this.generateJsonRequest(),
            "statusTemplate": "1",
            'button': form.get('template-buttons'),
        }

        if (mediaType !== 'text') {
            messageDetail['idUpload'] = form.get('idUploadTemplate');
            messageDetail['idSession'] = form.get('idSessionTemplate');
        }
        
        if(form.get('category-id') === '1') {
            messageDetail['type'] = 'hsm';
            messageDetail['media_type'] = 'text';
            messageDetail['add_security_recommendation'] = form.get('add-security-recommendation');
            messageDetail['code_expiration_minutes'] = form.get('code-expiration-minutes');
            messageDetail['raw_message'] = form.get('body-template');
            messageDetail['raw_message_footer'] = form.get('footer-template');
            messageDetail['total_param_body'] = 1;
        } else {
            messageDetail['type'] = strHeaderId;
            messageDetail['media_type'] = mediaType;
            messageDetail['raw_message'] = form.get('body-template');
            messageDetail['raw_message_header'] = rawHeader;
            messageDetail['raw_message_footer'] = form.get('footer-template');
            messageDetail['total_param_body'] = `${paramBody}`;
            messageDetail['total_param_header'] = `${paramHeader}`;

            if (form.get('template-type') === "lto") {
                messageDetail['raw_message_footer'] = '';
                messageDetail['limited_offer_text'] = form.get('limited-offer-text');
                messageDetail['offer_has_expiration'] = form.get('offer-has-expiration')===true ? 1 : 0;
            }
            if (form.get('template-type') === 'carousel') {
                messageDetail['raw_message_footer'] = '';
                messageDetail['carousel'] = this.setRequestCarousel(form.get("template-carousels"));
                messageDetail['idUpload'] = form.get('idUploadTemplate');
                messageDetail['idSession'] = form.get('idSessionTemplate');
            }
        }

        let data = {
            "client_id": `${form.get('client-id')}`,
            "division_id": form.get('division-id'),
            "sender_id": form.get('sender-id'),
            "idCategory": form.get('category-id'),
            "templateName": form.get('template_name'),
            "templateType": form.get('template-type'),
            "name_space": form.get('namespace'),
            "messageDetail": messageDetail
        }
        let body = {
            "data": data
        }
        
        let response = await this.props.actionAdd(body)
        if (response.ok) {
            toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        } else {
            toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }

    }

    handleModal() {
        let formVal = this.state.form
        let textHeader = this.state.form.get('header-template')
        let textHeaderReplace = ''
        let stringParam = ''
        for (let i = 0; i < textHeader.length; i++) {
            if (textHeader[i] == "{" && textHeader[i + 1] == "{") {
                stringParam = (textHeader.substring(i, i + 5))
                if (this.state.form.get('header-example-template') != '' || this.state.form.get('header-example-template') != "") {
                    textHeaderReplace = textHeader.replace(stringParam, this.state.form.get('header-example-template'))
                } else {
                    textHeaderReplace = textHeader.replace(stringParam, "")
                }
            }
        }
        let stringParam2 = ''
        let stringIndex = ''
        // Removed useless assignment to stringcheck and index
        let textbody = this.state.form.get('body-template')
        let count = 1
        let arrnum = []
        for (let i = 0; i < textbody.length; i++) {
            if (textbody[i] == "{" && textbody[i + 1] == "{") {
                // index and stringcheck are assigned here as needed
                let index = textbody.indexOf("}", i);
                let stringIndex = textbody.substring(i, index + 2);
                let stringcheck = stringIndex.substring(2, stringIndex.length - 2);
                stringParam2 = (textbody.substring(i, index + 2));
                if (this.state.formParamsBody.get("param-" + stringcheck) != undefined) {
                    textbody = textbody.replace(stringParam2, " " + this.state.formParamsBody.get("param-" + stringcheck) + " ")
                } else {
                    textbody = textbody.replace(stringParam2, " ")
                }
                if (arrnum.includes(stringcheck)) {

                } else {
                    arrnum.push(stringcheck)
                    count += 1
                }
            }
        }
        if (this.state.paramHeader > 0) {
            formVal = formVal.set('header-example-preview', textHeaderReplace);
        } else {
            formVal = formVal.set('header-example-preview', textHeader);
        }
        formVal = formVal.set('header-example-preview', textHeaderReplace);
        formVal = formVal.set('body-example-preview', textbody);
        this.setState({ form: formVal })
        this.setState({ modal: true })
        this.bodyBuild(count)
    }
    handleCancelModal() {
        let formVal = this.state.form
        let formval2 = this.state.formParamsBody
        let formval3 = this.state.formParamsBody2
        let artep = this.state.arrayTemp
        if (formVal.get('header-example-final') != "") {
            formVal = formVal.set('header-example-template', formVal.get('header-example-final'));
        } else {
            formVal = formVal.set('header-example-template', "");
        }

        for (let i = 0; i < artep.length; i++) {
            let a = formval2.get("param-" + artep[i])
            if (formval2.get("param-" + artep[i]) != undefined || formval2.get("param-" + artep[i] != "")) {
                formval2 = formval2.set('param-' + artep[i], "")

            }
            if (formval2.get("param-" + artep[i]) == "") {
                formval2 = formval2.remove("param-" + artep[i])
            }
        }
        formval2 = formval3

        this.setState({ form: formVal, formParamsBody: formval2, counterParam: formval2.size })
        this.setState({ parameterBody: this.state.parameterBody2, modal: false, flagempty: false })
    }

    handlesubmitModal() {
        const { formParamsBody, form, parameterBody } = this.state
        let formVal = this.state.form
        formVal = formVal.set('header-preview-final', formVal.get('header-example-preview'));
        formVal = formVal.set('body-preview-final', formVal.get('body-example-preview'));
        formVal = formVal.set('header-example-final', formVal.get('header-example-template'));
        for (let i = 0; i < this.state.counterParam; i++) {
            if (formParamsBody.get("param-" + (i + 1)) == '') {
                let string = "parameter " + (i + 1)
                toast.error(string + " cannot be empty", toast.POSITION.TOP_RIGHT);
                return false
            }
        }
        if (this.state.paramHeader > 0) {
            if (form.get("header-example-template") == '') {
                toast.error("header parameter cannot be empty", toast.POSITION.TOP_RIGHT);
                return false
            }
        }

        this.setState({ form: formVal, formParamsBody2: formParamsBody, parameterBody2: parameterBody, arrayTemp: [] })
        this.setState({ modal: false, flagempty: true, hideror: 'hide' })
    }

    handleChangeParam(field, value) {
        let stringParam = ''
        var formVal = this.state.formParamsBody;
        var formValform = this.state.form;
        formVal = formVal.set(field, value);
        this.setState({ formParamsBody: formVal })
        let str = ''
        let stringIndex = ''
        let stringcheck = ''
        let index = 0
        let textbody = this.state.form.get('body-template')
        let count = 0
        for (let i = 0; i < textbody.length; i++) {
            if (textbody[i] == "{" && textbody[i + 1] == "{") {
                count += 1
                index = textbody.indexOf("}", i)
                stringIndex = textbody.substring(i, index + 2)
                stringcheck = stringIndex.substring(2, stringIndex.length - 2)
                str = formVal.get("param-" + count)
                stringParam = (textbody.substring(i, index + 2))
                textbody = textbody.replace(stringParam, " " + str + " ")

            }
        }

        formValform = formValform.set('body-example-preview', textbody);
        this.setState({ form: formValform })
    }
    bodyBuild(count) {
        var arrtem = this.state.arrayTemp
        var xparams = this.state.parameterBody;
        var formParams = this.state.formParamsBody;
        for (let i = 0; i < count - 1; i++) {
            const id = `param-${i + 1}`
            const lbl = `parameter ${i + 1}`
            if (this.state.formParamsBody.get("param-" + (i + 1)) != undefined) continue
            xparams = xparams.set(i + 1, fromJS({ 'id': id, 'label': lbl }))
            formParams = formParams.set(id, '')
            arrtem.push(i + 1)
        }
        if (formParams.size < xparams.size || (count - 1) < xparams.size) {
            let sizeparam = xparams.size
            for (let j = (count - 1); j < sizeparam; j++) {
                formParams = formParams.remove("param-" + (j + 1))
                xparams = xparams.remove(j + 1)
            }
        }
        this.setState({ parameterBody: xparams, formParamsBody: formParams, counterParam: (count - 1), arrayTemp: arrtem });
    }
    renderParamBody() {

        const { formParamsBody, parameterBody, errors } = this.state
        return parameterBody.toList().map((item) => {
            const field = item.get('id')
            const lbl = item.get('label')
            return (
                <div className="col-sm-12 ">
                    <TextInputField className="form-control-text"
                        field={field}
                        value={formParamsBody.get(field)}
                        onChange={(field, value) => this.handleChangeParam(field, value)}
                        placeholder={lbl}
                        hasError={errors.has(field)}
                    />
                </div>
            )
        })

    }

    renderModal() {

        const { form, errors, disabled, modal } = this.state;
        let hidehead = ''
        let hidebody = ''
        let hidebox = ''
        if (form.get('header-template') != 'IMAGE' && form.get('header-template') != 'VIDEO' &&
            form.get('header-template') != 'DOCUMENT' && form.get('header-template') != "") {
            hidehead = ''
        } else {
            hidehead = 'hide'
        }

        if (this.state.paramHeader > 0) {
            hidebox = ''
        } else {
            hidebox = 'hide'
        }
        if (form.get('body-template') == '' || form.get('body-template') == "") {
            hidebody = 'hide'
        } else {
            hidebody = ''
        }
        return (
            <Modal
                show={modal} dialogClassName="custom-modal"  >
                <Modal.Header>
                    <Modal.Title>Add Example Template</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="col-md-8  nopadding ">
                        <div className="card noborder-left noborder-right card_noborderradius">
                            <div className="body msg_card_body template-body" ref={(el) => { this.messagesEnd = el; }}>
                                <div className='row no-margin-bottom col-sm-12'>
                                    <p className='col-sm-12 justify-text'>To help us understanding what kind of message you want to send you have the
                                        option to provide specific content examples for your template.</p>
                                    <p className='col-sm-12 justify-text'>You can add a
                                        sample template for one or all languages you are submitting</p>
                                    <span className={`col-sm-12 font-weight-bold ${hidehead}`}>
                                        Header<br />
                                    </span>

                                    <p className={`col-sm-12 ${hidehead}`}>{form.get('header-template')}</p>
                                    <div className={`col-sm-12 ${hidebox}`}>
                                        <TextInputField
                                            className="form-control-text"
                                            field={'header-example-template'}
                                            value={form.get('header-example-template')}
                                            onChange={(field, value) => this.handleChange(field, value)}
                                            placeholder="Header"
                                            disabled={disabled}
                                            hasError={errors.has('header-example-template')}
                                        />
                                    </div>
                                    <span className={`col-sm-12 font-weight-bold ${hidebody}`}>
                                        Body<br />
                                    </span>
                                    <p className={`col-sm-12${hidebody}`}>{form.get('body-template')}</p>
                                    {
                                        this.renderParamBody()
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-md-4 nopadding">
                        <PreviewMessage
                            rawMessage={this.state.isAuthentication ? null : form.get('body-example-preview')}
                            textHeader={this.state.isAuthentication ? null : form.get('header-example-preview')}
                            textFooter={this.state.isAuthentication ? null : form.get('footer-template')}
                            type={this.state.isAuthentication ? null : form.get('header-id') === 'hsm' ? 'text' : 'media'}
                            mediaType={this.state.isAuthentication ? null : form.get('header-template').toLowerCase()}
                        />
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary" onClick={this.handlesubmitModal}>Done</button>
                    <button type="button" className="btn btn-secondary" onClick={this.handleCancelModal}>Cancel</button>
                </Modal.Footer>
            </Modal>

        )
    }
    checkparam(indexs, value, tinyvalue, counter) {
        var formVal = this.state.form
        var value = value
        var content = tinyvalue
        var regex = /[^0-9]/g;
        var falseParam = 1
        let stringcheck = ''
        let stringIndex = ''
        let index = 0
        for (let i = indexs; i < value.length; i++) {

            if (value[i] == "{" && value[i + 1] == "{") {
                index = value.indexOf("}", i)
                if (value[index + 1] == "}") {
                    stringIndex = value.substring(i, index + 2)
                    stringcheck = stringIndex.substring(2, stringIndex.length - 2)
                    if (parseInt(stringcheck) > 0 && parseInt(stringcheck) > counter){
                        content = content.replaceAll("" + stringIndex + "", "");
                        stringIndex = "";
                        let stringfirst = value.substr(0, i - 1);
                        let stringend = value.substr(index + 2, value.length);
                        value = stringfirst + stringIndex + stringend + " ";
                        formVal = formVal.set('body-template', value);
                        this.setState({ form: formVal, tinyhtml: content });
                    }
                }
            }
        }
    }

    render() {
        const { paramBody, tinyhtml, hideror, form, errors, disabled, templateHeader, hideMediaHeader, hideTextHeader, isAuthentication, headerMediaType, limitedOfferTextLength, editorHtmlCarousels, listFlow } = this.state;
        const detailLto = {
            id: {
                limitedOfferText: form.get('limited-offer-text'),
                offerHasExpiration: form.get('offer-has-expiration'),
                offerTimeExpiredText: 'Penawaran berakhir pada <EXPIRATION TIME>',
                codeText: 'Kode <OFFER_CODE>',
            },
            en: {
                limitedOfferText: form.get('limited-offer-text'),
                offerHasExpiration: form.get('offer-has-expiration'),
                offerTimeExpiredText: 'Offer ends on <EXPIRATION TIME>',
                codeText: 'Code <OFFER_CODE>',
            }
        }
        const ltoPreview = form.get("lang-code") === 'id' ? detailLto.id : detailLto.en;
        const hideHeader = isAuthentication || form.get("template-type") === 'carousel' || form.get("template-type") === 'catalog';
        return (
            <div className="card no-margin-bottom">
                <div className="body">
                    {this.renderModal()}
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Client</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='client-id'
                                value={form.get('client-id')}
                                options={fromJS({
                                    'source': this.props.clientall,
                                    'value': 'client-id',
                                    'label': 'client-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Client"
                                disabled={this.state.disabledHead}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Division</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='division-id'
                                value={form.get('division-id')}
                                options={fromJS({
                                'source': this.props.divisionall,
                                'value': 'division-id',
                                'label': 'division-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Division"
                                disabled={this.state.disabledHead}
                                // hasError={errors.has('division-id')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Sender</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='sender-id'
                                value={form.get('sender-id')}
                                options={fromJS({
                                'source': this.props.senderall,
                                'value': 'sender-id',
                                'label': 'sender-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Sender"
                                disabled={this.state.disabledHead}
                                // hasError={errors.has('sender-id')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Name</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'template_name'}
                                value={form.get('template_name')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="template_name"
                                disabled={disabled}
                                hasError={errors.has('template_name')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Category</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='category-id'
                                value={form.get('category-id')}
                                options={fromJS({
                                    'source': this.state.category,
                                    'value': 'id',
                                    'label': 'name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Category"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Language</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='language-id'
                                value={form.get('language-id')}
                                options={fromJS({
                                    'source': this.props.languageTemplate,
                                    'value': 'lang_code',
                                    'label': 'language'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Language"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Name Space</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='namespace'
                                value={form.get('namespace')}
                                options={fromJS({
                                    'source': this.props.getnamespace,
                                    'value': 'namespace',
                                    'label': 'namespace'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="namespace"
                            />
                        </div>
                    </div>
                    {(form.get('category-id') === "2" || form.get('category-id') === "3") && (
                        <div className="row no-margin-bottom">
                            <span className="col-sm-2">Template Type</span>
                            <div className="col-sm-10">
                                <ComboboxInput
                                    field='template-type'
                                    value={form.get('template-type')}
                                    options={fromJS({
                                        'source': (form.get('category-id')==="2") ? this.state.templateType : this.state.templateTypeUtility,
                                        'value': 'id',
                                        'label': 'name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Template Type"
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div id="chat-container">
                    <div className="col-md-12 nopadding">
                        <div className="col-md-9  nopadding">
                            <div className="card noborder-left noborder-right card_noborderradius">
                                <div className="header">

                                    <h5>Add Template</h5>
                                    <button type="button"
                                        className={`btn btn-primary btn-md ${isAuthentication ? 'hide' : ''}`}
                                        onClick={this.handleModal}
                                        disabled={this.state.disabledModal}
                                    >
                                        {"Add Sample"}
                                    </button>
                                    <span className={`col-md-12 nopadding error ${hideror}`}>Please add sample for each parameter</span>
                                </div>
                                <div className="body msg_card_body template-body" ref={(el) => { this.messagesEnd = el; }}>
                                <div className={`row no-margin-bottom col-sm-12 ${hideHeader ? 'hide' : ''}`}>
                                    <span className='col-sm-12 font-weight-bold'>
                                        Header<br />
                                        <span style={{fontSize: '10pt'}}>Add a title or choose which type of media you'll use for this header.</span>
                                    </span>
                                    <div className="col-sm-4">
                                        <ComboboxInput
                                            field='header-id'
                                            value={form.get('header-id')}
                                            options={fromJS({
                                                'source': templateHeader,
                                                'value': 'header-id',
                                                'label': 'header-name'
                                            })}
                                            onChange={(field, value, label) => this.handleChange(field, value, label)}
                                            placeholder="Header"
                                            disabled={this.state.statDisableButton || this.state.headerTextOnly}
                                        />
                                    </div>
                                    <div className={`col-sm-7 ${hideMediaHeader}`}>
                                        <ComboboxInput
                                            field='header-template'
                                            value={form.get('header-template')}
                                            options={fromJS({
                                                'source': headerMediaType,
                                                'value': 'header-media-id',
                                                'label': 'header-media-id'
                                            })}
                                            onChange={(field, value, label) => this.handleChange(field, value, label)}
                                            placeholder="Media"
                                            disabled={this.state.statDisableButton}
                                        />
                                    </div>
                                    <div className={`col-sm-7 ${hideTextHeader}`}>
                                        <TextInputField
                                            className="form-control-text"
                                            field={'header-template'}
                                            value={form.get('header-template')}
                                            onChange={(field, value) => this.handleChange(field, value)}
                                            placeholder="Header"
                                            disabled={disabled}
                                            hasError={errors.has('header-template')}
                                        />
                                    </div>
                                    <div className={`col-sm-1 headchar ${hideTextHeader}`}>
                                        {this.state.totalcharhead + "/60"}
                                    </div>
                                    <div className={`col-sm-1 buttonheader ${hideTextHeader}`}>
                                        <button type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={this.handleParamHeader}
                                            disabled={this.state.disabledparam}
                                        >
                                            {'{{}}'}
                                        </button>
                                    </div>
                                    <div className={`col-sm-12 mb-0 ${hideMediaHeader}`}>
                                        <span className="col-sm-4">Example File</span>
                                        <div className="col-sm-7 mb-0">
                                            <input className="form-control"
                                                type="file"
                                                name="file"
                                                disabled={this.state.statDisableButton}
                                                style={{ display: this.state.statButtonUpload }}
                                                key={form.get('file-key')}
                                                onClick={e => (e.target.value = null)}
                                                onChange={this.handleOnFileChanged}
                                            />
                                            <p>{this.state.fileNameExamp}</p>
                                        </div>
                                    </div>
                                    <div className={`col-sm-12 ${hideMediaHeader}`}>
                                        <button type="button"
                                            className="btn btn-info mr-2"
                                            disabled={this.state.statDisableButton}
                                            onClick={this.handleUploadFile}>
                                            Upload
                                        </button>
                                        <button type="button"
                                            className="btn btn-danger"
                                            disabled={!this.state.statDisableButton}
                                            onClick={this.handleCancelFile}>
                                            Change
                                        </button>
                                    </div>
                                </div>

                                    <div className={`row no-margin-bottom col-sm-12`}>
                                        <span className='col-sm-12 font-weight-bold no-margin-bottom'>
                                            Body<br />
                                            <span className={`${isAuthentication ? 'hide' : ''}`}>
                                                <span style={{fontSize: '10pt'}}>Enter the text for your message in the language you've selected.</span>
                                                <Tooltip title={
                                                    <React.Fragment>
                                                        <Typography variant="h6" color="inherit">Maximum 2 times concecutively for spacing 'ENTER'</Typography>
                                                    </React.Fragment>
                                                } >
                                                    <button><i className='small-icon' ><InfoIcon /></i></button>
                                                </Tooltip>
                                            </span>
                                        </span>
                                        <div className={`col-sm-12 pt-2`}>
                                            <div>
                                                <EditorMessage
                                                    value={tinyhtml}
                                                    lengthValue={
                                                        form.get('body-template')
                                                        ? form.get('body-template').length
                                                        : 0
                                                    }
                                                    onChange={this.onEditorChange}
                                                    setParamSize={this.setParamSize}
                                                    paramSize={paramBody}
                                                    disabled={disabled || isAuthentication}
                                                    placeholder={'Input message here...'}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {form.get('template-type') !== "lto" && form.get('template-type') !== "carousel" && (
                                        <div className="row no-margin-bottom col-sm-12">
                                            <span className='col-sm-12 font-weight-bold no-margin-bottom'>
                                                Footer<br />
                                            </span>
                                            <div className={`col-sm-12`}>
                                                <span style={{fontSize: '10pt', fontWeight: 'bold'}}> Add a short line of text to the bottom of your message template.</span>
                                                <TextInputField
                                                    className="form-control"
                                                    field={'footer-template'}
                                                    value={form.get('footer-template')}
                                                    onChange={(field, value) => this.handleChange(field, value)}
                                                    placeholder="Footer"
                                                    disabled={disabled || isAuthentication}
                                                    hasError={errors.has('footer-template')}
                                                />
                                                <div className={`col-sm-1 footerchar `}>
                                                    {isAuthentication ? form.get('footer-template').length + "/60" : this.state.totalcharfooter + "/60"}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {form.get('template-type') === "lto" && (
                                        <>
                                            <div className="row no-margin-bottom col-sm-12">
                                                <p className="col-sm-12 mb-0">
                                                    <span className="font-weight-bold">
                                                        Limited-time offer
                                                    </span>
                                                    {!disabled && (
                                                        <React.Fragment>
                                                            <br />
                                                            <span className="font-weight-light">
                                                                Add a short line of text
                                                                for detail promo.
                                                            </span>
                                                        </React.Fragment>
                                                    )}
                                                </p>
                                                <div className={`col-sm-12`}>
                                                    <TextInputField
                                                        className="form-control pr-5"
                                                        field={"limited-offer-text"}
                                                        value={form.get(
                                                            "limited-offer-text"
                                                        )}
                                                        onChange={(field, value) =>
                                                            this.handleChange(
                                                                field,
                                                                value
                                                            )
                                                        }
                                                        maxLength={limitedOfferTextLength}
                                                        placeholder={
                                                            disabled
                                                                ? ""
                                                                : "Input Limited-time offer text here..."
                                                        }
                                                        disabled={disabled}
                                                        hasError={errors.has(
                                                            "limited-offer-text"
                                                        )}
                                                    />
                                                    <span className="length-footer">
                                                        {
                                                            form.get(
                                                                "limited-offer-text"
                                                            ).length
                                                        }
                                                        /{limitedOfferTextLength}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <CheckBoxInputField className="form-control"
                                                    field={"offer-has-expiration"}
                                                    checked={form.get('offer-has-expiration')}
                                                    onChange={(field, value) => this.handleChange(field, value)}
                                                    label="Has expiration"
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div className={`col-sm-12 pt-3 ${isAuthentication ? '' : 'hide'}`}>
                                        <CheckBoxInputField className="form-control"
                                            field={"add-security-recommendation"}
                                            checked={form.get('add-security-recommendation')}
                                            onChange={(field, value) => this.handleChange(field, value)}
                                            label="Add Security Recommendation"
                                        />
                                    </div>
                                    <div className={`row no-margin-bottom col-sm-12 ${isAuthentication ? '' : 'hide'}`}>
                                        <div className={`col-sm-3`}>
                                            <span>Code Expirations</span>
                                        </div>
                                        <div className={`col-sm-3`}>
                                            <TextInputField
                                                number
                                                className="form-control"
                                                field={'code-expiration-minutes'}
                                                value={form.get('code-expiration-minutes')}
                                                onChange={(field, value) => this.handleChange(field, value)}
                                                placeholder="1-90"
                                                disabled={disabled}
                                                hasError={errors.has('code-expiration-minutes')}
                                            />
                                        </div>
                                        <div className={`col-sm-3 mt-3 ml-0`}>
                                            <Tooltip title={
                                                <React.Fragment>
                                                    <Typography variant="h6" color="inherit">Indicates number of minutes the password or code is valid. Minimum 1, maximum 90.</Typography>
                                                </React.Fragment>
                                            } >
                                                <button><i className='small-icon' ><InfoIcon /></i></button>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    {form.get("template-type") !== "carousel" ? (
                                        <ButtonManager
                                            categoryId={form.get('category-id')}
                                            templateType={form.get('template-type')}
                                            disabled={disabled}
                                            items={form.get('template-buttons')}
                                            ltoData={form.get('lto-buttons')}
                                            listFlow={listFlow}
                                            onChange={(field, value) => this.handleChange(field, value)}
                                            hasError={errors.has('template-buttons')}
                                        />
                                    ) : (
                                        <div className="input-carousel-wrapper">
                                            {form.get("template-carousels").map((card, index) => (
                                                <CardCarousel
                                                    key={`card-carousel-${index+1}`}
                                                    disabled={disabled}
                                                    editorHtmlCarousels={editorHtmlCarousels}
                                                    index={index}
                                                    errors={errors}
                                                    handleChange={this.handleChangeInCardCarousel}
                                                    onEditorChange={this.onEditorCardCarouselChange}
                                                    setParamSize={this.setParamSizeCardCarousel}
                                                    buttons={card.get("template-buttons")}
                                                    paramSize={card.get("param_size")}
                                                    rawMessage={card.get("raw_message")}
                                                    format={card.get("format")}
                                                    categoryId={form.get("category-id")}
                                                    statDisableButton={this.state.statDisableButton}
                                                    statButtonUpload={this.state.statButtonUpload}
                                                    fileKey={form.get('file-key')}
                                                    fileNameExamp={this.state.fileNameExamp}
                                                    handleOnFileChanged={this.handleOnFileChanged}
                                                    handleUploadFile={this.handleUploadFile}
                                                    handleCancelFile={this.handleCancelFile}
                                                    onRemove={form.get("template-carousels").size > 1 && this.deleteCardCarousel}
                                                    onAddMoreCard={form.get("template-carousels").size === index+1 && form.get("template-carousels").size < 10 ? this.addMoreCardCarousel : null}
                                                />
                                            ))}
                                        </div>
                                    )}
                                    <div className="row no-margin-bottom">
                                        <div className="col-sm-4">
                                            <button type="button"
                                                className="btn btn-wide btn-success"
                                                onClick={this.handleSubmit}>
                                                Submit
                                            </button>
                                        </div>
                                        <div className="col-sm-4">
                                            <button type="button"
                                                className="btn btn-wide btn-warning"
                                                onClick={this.handleSavetoDraft}>
                                                Save To Draft
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row no-margin-bottom">
                                        <div className="col-sm-4">
                                            <button type="button"
                                                className="btn btn-wide btn-danger"
                                                onClick={this.handleCancel}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="col-md-3 nopadding">
                            <PreviewMessage
                                textHeader={this.state.isAuthentication ? null : form.get('header-preview-final')}
                                rawMessage={form.get('body-preview-final')}
                                textFooter={form.get('footer-template')}
                                type={this.state.isAuthentication ? null : form.get('header-id') === 'hsm' ? 'text' : 'media'}
                                mediaType={this.state.isAuthentication ? null : form.get('header-template').toLowerCase()}
                                buttons={form.get('template-buttons')}
                                cardCarousel={form.get("template-type") === 'carousel'
                                                && <CardCarouselPreview templateCarousels={form.get("template-carousels")} />}
                                lto={form.get("template-type") === 'lto' && ltoPreview }
                            />
                        </div>
                    </div>
                </div>
            </div>

        );

    }
}


export default connect(
    (state) => {
        return {
            supervisorsall: state.user.supervisorsall,
            grouptemplate: state.user.grouptemplate,
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            categoryTemplate: state.user.categoryTemplate,
            languageTemplate: state.user.languageTemplate,
            getnamespace: state.user.getnamespace,
            accessmoduleaction: state.user.accessmoduleaction,
        }
    },
    dispatch => bindActionCreators({
        actionUploadFileExample: ActionUploadFileExample,
        actionAdd: ActionAdd,
        actionGetAllClient: ActionGetAllClient,
        actionFetchAllDivision: ActionFetchAllDivision,
        actionFetchSender: ActionFetchSender,
        actionGetCategoryTemplate: ActionGetCategoryTemplate,
        actionGetLanguageTemplate: ActionGetLanguageTemplate,
        actionGetNameSpace: ActionGetNameSpace,
        actionGetAccessModuleIdAction: ActionGetAccessModuleIdAction,
    }, dispatch),
)(Form);